import React from 'react';
import Geolocation from './components/Geolocation';
import Nav from './components/Nav'
import Footer from './components/Footer'

const App = () => {
    return (
        <div className="Fade" id="top">
            <Nav />
            <Geolocation />
            <Footer />
        </div>
    );
};
export default App;
